import { useParams, useSearchParams } from "react-router-dom";

function useNavigationParams() {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const jsonSearchParams = {};
  for (const entry of searchParams.entries()) {
    const [param, value] = entry;

    jsonSearchParams[param] = value;
  }

  return {
    params,
    searchParams: jsonSearchParams,
  };
}

export default useNavigationParams;
